export const VALIDATOR_DEMAT_FACILE = 1;

export const VALIDATOR_TYPE_GREFFE = 1;
export const VALIDATOR_TYPE_IMPOTS = 7;
export const VALIDATOR_TYPE_LEGAL_ANNOUCEMENT = 4;
export const VALIDATOR_TYPE_BODACC = 10;

export const PROCESS_STATUS_FLAG_PENDING = 100;
export const PROCESS_STATUS_FLAG_ONGOING = 200;
export const PROCESS_STATUS_FLAG_ERROR = 300;
export const PROCESS_STATUS_FLAG_DONE = 400;
export const PROCESS_STATUS_FLAG_FAILED = 500;
